// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d6b51530","276":"9ed170c7","302":"c48652b1","313":"ae3d3f76","472":"276d96c2"}[chunkId] + ".chunk.js";
};